module.exports = __webpack_public_path__ + "static/media/schlauch_loesung2.5657a01f.jpg";